import React from 'react';
import { Code, Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, ArrowRight } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Solutions',
      links: [
        { name: 'ERP for Education', href: '#erp' },
        { name: 'Facial Recognition', href: '#facial-recognition' },
        { name: 'RFID Systems', href: '#rfid' },
        { name: 'Custom Development', href: '#custom-dev' }
      ]
    },
    {
      title: 'Services',
      links: [
        { name: 'Software Development', href: '#software' },
        { name: 'System Integration', href: '#integration' },
        { name: 'Technical Support', href: '#support' },
        { name: 'Consulting', href: '#consulting' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '#about' },
        { name: 'Our Team', href: '#team' },
        { name: 'Careers', href: '#careers' },
        { name: 'News & Updates', href: '#news' }
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Documentation', href: '#docs' },
        { name: 'Help Center', href: '#help' },
        { name: 'Contact Support', href: '#contact' },
        { name: 'System Status', href: '#status' }
      ]
    }
  ];

  const socialLinks = [
    { icon: <Facebook size={20} />, href: '#facebook', name: 'Facebook' },
    { icon: <Twitter size={20} />, href: '#twitter', name: 'Twitter' },
    { icon: <Linkedin size={20} />, href: '#linkedin', name: 'LinkedIn' },
    { icon: <Instagram size={20} />, href: '#instagram', name: 'Instagram' }
  ];

  const contactInfo = [
    { icon: <Phone size={16} />, text: '+91 91016 33479' },
    { icon: <Mail size={16} />, text: 'info@rootsofnortheast.com' },
    { icon: <MapPin size={16} />, text: 'Kokrajhar, Assam, India' }
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Main Footer Content */}
        <div className="footer__main">
          {/* Company Info */}
          <div className="footer__company">
            <div className="footer__logo">
              <div className="footer__logo-icon">
                <Code className="footer__logo-icon-svg" />
              </div>
              <span className="footer__logo-text">Roots of Northeast</span>
            </div>

            <p className="footer__company-description">
              Leading technology company specializing in innovative software solutions
              and SaaS products for educational institutions and businesses across Northeast India.
            </p>

            <div className="footer__contact-info">
              {contactInfo.map((info, index) => (
                <div key={index} className="footer__contact-item">
                  {info.icon}
                  <span>{info.text}</span>
                </div>
              ))}
            </div>

            <div className="footer__social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="footer__social-link"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          <div className="footer__links">
            {footerSections.map((section, index) => (
              <div key={index} className="footer__section">
                <h3 className="footer__section-title">{section.title}</h3>
                <ul className="footer__section-links">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.href} className="footer__section-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Newsletter Signup */}
          <div className="footer__newsletter">
            <h3 className="footer__newsletter-title">Stay Updated</h3>
            <p className="footer__newsletter-description">
              Subscribe to our newsletter for the latest updates on our products and services.
            </p>

            <form className="footer__newsletter-form">
              <div className="footer__newsletter-input-group">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="footer__newsletter-input"
                  required
                />
                <button type="submit" className="footer__newsletter-button">
                  <ArrowRight size={16} />
                </button>
              </div>
            </form>

            <p className="footer__newsletter-disclaimer">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom">
          <div className="footer__bottom-content">
            <div className="footer__copyright">
              <p>&copy; {currentYear} Roots of Northeast. All rights reserved.</p>
            </div>

            <div className="footer__legal">
              <a href="/important_documents/Privacy%20Policy.html" target="_blank" rel="noopener noreferrer" className="footer__legal-link">Privacy Policy</a>
              <a href="/important_documents/Refund%20Policy.html" target="_blank" rel="noopener noreferrer" className="footer__legal-link">Refund Policy</a>
              <a href="#terms" className="footer__legal-link">Terms of Service</a>
              <a href="#cookies" className="footer__legal-link">Cookie Policy</a>
              <a href="#disclaimer" className="footer__legal-link">Disclaimer</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
